import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "mt-3"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = { key: 1 };
import { ref } from 'vue';
import { uploadVoucher } from '@/api/public/client';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherUpload',
    props: {
        completeUpload: { type: Function }
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var fileInput = ref(null);
        var preview = ref(null);
        var subID = ref(0);
        function setSubID(id) {
            subID.value = id;
        }
        function openFilePicker() {
            var _a;
            (_a = fileInput.value) === null || _a === void 0 ? void 0 : _a.click();
        }
        function handleFileChange(event) {
            var target = event.target;
            if (target.files && target.files.length > 0) {
                processFile(target.files[0]);
            }
        }
        function handleDrop(event) {
            var _a;
            var files = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
            if (files && files.length > 0) {
                processFile(files[0]);
            }
        }
        function handlePaste(event) {
            var _a;
            var items = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.items;
            if (items) {
                var fileItem = Array.from(items).find(function (item) { return item.kind === 'file'; });
                var file = fileItem === null || fileItem === void 0 ? void 0 : fileItem.getAsFile();
                if (file) {
                    processFile(file);
                }
            }
        }
        function processFile(file) {
            var reader = new FileReader();
            reader.onload = function () {
                preview.value = {
                    name: file.name,
                    type: file.type,
                    preview: reader.result,
                };
                uploadFile(file);
            };
            reader.readAsDataURL(file);
        }
        function uploadFile(file) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var formData, response;
                return __generator(this, function (_b) {
                    formData = new FormData();
                    formData.append('file', file);
                    try {
                        response = uploadVoucher(subID.value, formData);
                        (_a = fileInput.value) === null || _a === void 0 ? void 0 : _a.remove();
                        preview.value = null;
                        props.completeUpload();
                    }
                    catch (e) {
                    }
                    return [2 /*return*/];
                });
            });
        }
        __expose({
            setSubID: setSubID,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "upload-area border border-dashed rounded p-4 text-center",
                onDragover: _cache[0] || (_cache[0] = _withModifiers(function () { }, ["prevent"])),
                onDrop: _withModifiers(handleDrop, ["prevent"]),
                onPaste: handlePaste,
                onClick: openFilePicker
            }, [
                _cache[1] || (_cache[1] = _createElementVNode("p", null, "Arrastra una imagen/documento aquí, haz clic para seleccionar o pega con Ctrl+V", -1)),
                _createElementVNode("input", {
                    type: "file",
                    ref_key: "fileInput",
                    ref: fileInput,
                    class: "d-none",
                    onChange: handleFileChange,
                    accept: "image/*,.pdf"
                }, null, 544),
                (preview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (preview.value.type.startsWith('image/'))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: preview.value.preview,
                                class: "img-thumbnail",
                                style: { "max-width": "200px" }
                            }, null, 8, _hoisted_2))
                            : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(preview.value.name), 1))
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
